export const SIDEBAR_OPEN = 'SIDEBAR_OPEN'
export const SIDEBAR_CLOSE = 'SIDEBAR_CLOSE'
export const GET_PRODUCTS_BEGIN = 'GET_PRODUCTS_BEGIN'
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS'
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR'
export const GET_SINGLE_PRODUCT_BEGIN = 'GET_SINGLE_PRODUCT_BEGIN'
export const GET_SINGLE_PRODUCT_SUCCESS = 'GET_SINGLE_PRODUCT_SUCCESS'
export const GET_SINGLE_PRODUCT_ERROR = 'GET_SINGLE_PRODUCT_ERROR'
export const LOAD_PRODUCTS = 'LOAD_PRODUCTS'
export const SET_GRIDVIEW = 'SET_GRIDVIEW'
export const SET_LISTVIEW = 'SET_LISTVIEW'
export const UPDATE_SORT = 'UPDATE_SORT'
export const SORT_PRODUCTS = 'SORT_PRODUCTS'
export const UPDATE_FILTERS = 'UPDATE_FILTERS'
export const FILTER_PRODUCTS = 'FILTER_PRODUCTS'
export const CLEAR_FILTERS = 'CLEAR_FILTERS'
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM'
export const TOGGLE_CART_ITEM_AMOUNT = 'TOGGLE_CART_ITEM_AMOUNT'
export const CLEAR_CART = 'CLEAR_CART'
export const COUNT_CART_TOTALS = 'COUNT_CART_TOTALS'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const SIGNUP_ERROR = 'SIGNUP_ERROR'
export const LOGOUT = 'LOGOUT'
export const SET_USER = 'SET_USER'
export const CREATE_SHOP_SUCCESS = 'CREATE_SHOP_SUCCESS'
export const CREATE_SHOP_ERROR = 'CREATE_SHOP_ERROR'
export const UPDATE_SHOP = 'UPDATE_SHOP'
export const LIST_SHOPS_BY_OWNER_SUCCESS = 'LIST_SHOPS_BY_OWNER_SUCCESS'
export const LIST_SHOPS_BY_OWNER_ERROR = 'LIST_SHOPS_BY_OWNER_ERROR'
export const DELETE_SHOP_SUCCESS = 'DELETE_SHOP_SUCCESS'
export const DELETE_SHOP_ERROR = 'DELETE_SHOP_ERROR'
export const READ_SHOP_SUCCESS = 'READ_SHOP_SUCCESS'
export const READ_SHOP_ERROR = 'READ_SHOP_ERROR'
export const LIST_PRODUCTS_BY_SHOP_SUCCESS = 'LIST_PRODUCTS_BY_SHOP_SUCCESS'
export const LIST_PRODUCTS_BY_SHOP_ERROR = 'LIST_PRODUCTS_BY_SHOP_ERROR'
export const DELETE_PORODUCT_SUCCESS = ' DELETE_PORODUCT_SUCCESS'
export const DELETE_PORODUCT_ERROR = 'DELETE_PORODUCT_ERROR'
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS'
export const GET_CATEGORIES_ERROR = 'GET_CATEGORIES_ERROR'
export const GET_COLORS_SUCCESS = 'GET_COLORS_SUCCESS'
export const GET_COLORS_ERROR = 'GET_COLORS_ERROR'
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS'
export const GET_COMPANIES_ERROR = 'GET_COMPANIES_ERROR'
export const PROFILE_EDIT_SUCCESS = 'PROFILE_EDIT_SUCCESS'
export const PROFILE_EDIT_ERROR = 'PROFILE_EDIT_ERROR'
